module.exports = __webpack_public_path__ + "static/img/fefco426_2.0a43cc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco426_2.png
// module id = Zejl
// module chunks = 0